import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Beta } from '../../widgets';
import { ChatCount } from '../../widgets/Common';

const MenuItem = ({ title, to, icon, iconImg, onClick, onSelect, className, name, children, visible, isBeta, isChat }) => {
    const messageCount = useSelector(state => state.chat.unreadMessageCount);
    let isActive = false;

    if (name) {
        const paths = window.location.pathname.toLowerCase().split('/');
        isActive = (paths.indexOf(name.toLowerCase()) >= 0);
    } else if (to) {
        const path = (typeof to === 'string') ? to : to.pathname;
        isActive = (path && window.location.pathname.toLowerCase() === path.toLowerCase());
    }

    className = className ? className : '';
    className += isActive ? ' active' : '';

    return (<li
        className={`nav-item ${className}`}
        title={title} >
        {to ?
            <NavLink
                exact
                activeClassName={`active`}
                className={`nav-link ${!visible && "hide"}`}
                to={to}
                onClick={onSelect ? onSelect.bind(this, name) : undefined}>
                {children}
                {iconImg ? <img src={iconImg} style={{ height: "22px" }} alt="" /> : <i className={icon} />}
                {isBeta && <Beta />}
                {isChat && messageCount > 0 && <ChatCount count={messageCount} />}
            </NavLink> :
            <span
                className={`nav-link ${!visible && "hide"}`}
                onClick={onClick}>
                {children}
                {iconImg ? <img src={iconImg} style={{ height: "22px" }} alt="" /> : <i className={icon} />}
                {isBeta && <Beta />}
            </span>
        }
    </li >)
}

export default MenuItem;